import authAxios from '../common/authAxios';

class FileUploadService {

  async uploadDocument(documentFile, type, callback) {
    const formData = new FormData();
    formData.append('documentFile', documentFile);

    return await authAxios.post(`/file/upload-document?type=${type}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: event => {
        typeof callback === 'function' && callback(event.loaded / event.total * 100);
      }
    });
  }

  async uploadDocuments(documentFiles, type, callback) {
    const formData = new FormData();
    for (let file of documentFiles) {
      formData.append('documentFiles', file);
    }
    // formData.append('documentFile', documentFiles);
    return await authAxios.post(`/file/upload-documents?type=${type}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: event => {
        typeof callback === 'function' && callback(event.loaded / event.total * 100);
      }
    });
  }

  async secretaryUploadDocument(fileId, documentFile) {
    const formData = new FormData();
    formData.append('documentFile', documentFile);

    return await authAxios.post(`/file/update-document?id=${fileId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
  }

  async secretaryUploadDocuments(application, files, type) {
    const formData = new FormData();
    for (let file of files) {
      formData.append('documentFiles', file);
    }
    console.log(application);
    return await authAxios.post(`/file/update-documents?type=${type}&user_id=${application.userDtoResponse.id}`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
  }

  async secretaryUploadAbiturDocument(documentFile, userId, type, callback) {
    const formData = new FormData();
    formData.append('documentFile', documentFile);

    return await authAxios.post(`/file/upload-document-secretary?type=${type}&user_id=${userId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: event => {
        typeof callback === 'function' && callback(event.loaded / event.total * 100);
      }
    });
  }
  getDocument(fileId, fileName) {
    // fileName = fileName.substring(0, fileName.lastIndexOf('.'));
    authAxios.get(`/file/get-document?id=${fileId}`)
      .then(response => {
        const extensionHeaderValue = response.headers['extension'];
        const linkSource = (extensionHeaderValue === 'pdf')
          ? `data:application/pdf;base64,${response.data}`
          : `data:application/octet-stream;base64,${response.data}`;

        // Почему-то 'substr()' при отсутствии нужной строки возвращает всю строку целиком... 
        if (!fileName.endsWith(`.${extensionHeaderValue}`)) {
          fileName += `.${extensionHeaderValue}`;
        }
    
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      })
      .catch(error => {
        console.log(error);
      });
  }
  getDocumentSecretary(userId, fileId, fileName) {
    // fileName = fileName.substring(0, fileName.lastIndexOf('.'));
    authAxios.get(`/file/get-document-secretary?id=${fileId}&user_id=${userId}`)
      .then(response => {
        const extensionHeaderValue = response.headers['extension'];
        const linkSource = (extensionHeaderValue === 'pdf')
          ? `data:application/pdf;base64,${response.data}`
          : `data:application/octet-stream;base64,${response.data}`;

        // Почему-то 'substr()' при отсутствии нужной строки возвращает всю строку целиком... 
        if (fileName === fileName.substr(fileName.lastIndexOf('.') + 1)) {
          fileName += `.${extensionHeaderValue}`;
        }

        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch(error => {
        console.log(error);
      });
  }

  deleteFile(fileId, userId) {
    if (userId) {
      return authAxios.delete(`/file/delete-document-office?id=${fileId}&userId=${userId}`)
    }
    else {
      return authAxios.delete(`/file/delete-document?id=${fileId}`)
    }
  }

}

export default FileUploadService;